import React, { useState } from "react";

const RadioGroup = ({ field, value, setFieldValue }) => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleRadioChange = (value) => {
        setSelectedValue(value);
        setFieldValue(field, value);
    };

    return (
        <div className="radio-group-container">
            <div className="radio-container">
                <input
                    className="radio-input"
                    type="radio"
                    id="Premium"
                    value="Premium"
                    checked={selectedValue === "Premium"}
                    onClick={() => handleRadioChange("Premium")}
                />
                <label
                    htmlFor="Premium"
                    className={`radio-label ${selectedValue === "Premium" ? "bold-label" : ""}`}
                >
                    Premium
                </label>

                <input
                    className="radio-input"
                    type="radio"
                    id="Freemium"
                    value="Freemium"
                    checked={selectedValue === "Freemium"}
                    onClick={() => handleRadioChange("Freemium")}
                />
                <label
                    htmlFor="Freemium"
                    className={`radio-label ${selectedValue === "Freemium" ? "bold-label" : ""}`}
                >
                    Freemium
                </label>
            </div>
        </div>
    );
};

export default RadioGroup;
